function getAllSubmenus() {
  return document.querySelectorAll(
    '.site-navigation__primary__sub-menu, .site-navigation__sub-menu, .sub-menu'
  );
}

function getTallestSubMenu() {
  let maxH = 0;
  getAllSubmenus().forEach((el) => {
    const h = el?.scrollHeight || el?.offsetHeight || 0;
    if (h > maxH) maxH = h;
  });
  return maxH;
}

function primeSubnavHeightVars(primaryEl) {
  const header = primaryEl.closest('.site-header');
  if (!header || header.dataset.subnavVarsPrimed === 'true') return;

  header.dataset.subnavVarsPrimed = 'true';

  const setVars = () => {
    const h = getTallestSubMenu();
    header.style.setProperty('--sub-nav-height', `${h}px`);
  };

 
  setVars();
  window.addEventListener('resize', setVars);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(setVars).catch(() => {});
  }
}

function wireHoverArea(primaryEl) {
  const header = primaryEl.closest('.site-header');
  const list = primaryEl.querySelector('.site-navigation__primary-list');
  if (!header || !list || list.dataset.navHoverWired === 'true') return;

  list.dataset.navHoverWired = 'true';

  let collapseTimer = null;
  const expand = () => {
    if (collapseTimer) { clearTimeout(collapseTimer); collapseTimer = null; }
    header.style.minHeight = `calc(var(--header-height) + var(--sub-nav-height, 0px))`;
  };
  const collapse = () => {
    header.style.minHeight = '0';
    const ref = header;
    setTimeout(() => {
      if (ref.style.minHeight === '0') ref.style.minHeight = '';
    }, 300);
  };

  list.addEventListener('mouseenter', expand);
  list.addEventListener('mouseleave', () => {
    if (collapseTimer) clearTimeout(collapseTimer);
    collapseTimer = setTimeout(() => {
      if (!list.matches(':hover')) collapse();
    }, 100);
  });

  list.addEventListener('focusin', expand);
  list.addEventListener('focusout', () => {
    setTimeout(() => {
      if (!list.contains(document.activeElement) && !list.matches(':hover')) {
        collapse();
      }
    }, 0);
  });
}


function navigation(submenu) {
  if (!submenu) return;

  const primary = submenu.closest('.site-navigation__primary');
  if (!primary) return;

  primeSubnavHeightVars(primary);
  wireHoverArea(primary);

  const isTouch =
    (window.matchMedia && window.matchMedia('(hover: none)').matches) ||
    (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) ||
    'ontouchstart' in window;

  const item = submenu.parentElement;
  if (!item) return;

  const trigger = item.querySelector(':scope > a, :scope > button');
  if (!trigger) return;

  const deactivateSiblings = () => {
    const siblings = item.parentElement ? Array.from(item.parentElement.children) : [];
    siblings.forEach((sib) => {
      if (sib !== item) {
        sib.classList.remove('site-navigation__menu-item--active');
        const sibSub = sib.querySelector(
          ':scope > .site-navigation__sub-menu, :scope > .site-navigation__primary__sub-menu, :scope > .sub-menu'
        );
        if (sibSub) sibSub.classList.remove('site-navigation__sub-menu--active');
        const sibTrigger = sib.querySelector(':scope > a, :scope > button');
        if (sibTrigger) sibTrigger.setAttribute('aria-expanded', 'false');
      }
    });
  };

  const openThis = () => {
    item.classList.add('site-navigation__menu-item--active');
    submenu.classList.add('site-navigation__sub-menu--active');
    trigger.setAttribute('aria-expanded', 'true');
  };

  const closeThis = () => {
    item.classList.remove('site-navigation__menu-item--active');
    submenu.classList.remove('site-navigation__sub-menu--active');
    trigger.setAttribute('aria-expanded', 'false');
  };

  trigger.setAttribute('aria-haspopup', 'true');
  trigger.setAttribute('aria-expanded', 'false');

  if (isTouch) {
    trigger.addEventListener('click', (e) => {
      if (item.classList.contains('site-navigation__menu-item--active')) {
        return;
      }
      e.preventDefault();
      deactivateSiblings();
      openThis();
    });

    document.addEventListener(
      'click',
      (evt) => { if (!primary.contains(evt.target)) closeThis(); },
      { passive: true }
    );
  } else {
    trigger.addEventListener('focus', () => {
      const listScope = item.parentNode || primary;
      listScope
        .querySelectorAll('.site-navigation__sub-menu--active')
        .forEach((el) => el.classList.remove('site-navigation__sub-menu--active'));
      listScope
        .querySelectorAll('.site-navigation__menu-item--active')
        .forEach((el) => el.classList.remove('site-navigation__menu-item--active'));
      listScope
        .querySelectorAll(':is(a,button)[aria-expanded="true"]')
        .forEach((t) => t.setAttribute('aria-expanded', 'false'));

      openThis();
    });
  }
}

function navicon() {
  const btn = document.querySelector('.site-navigation__navicon');
  if (!btn) return;

  btn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.toggle('site-navigation__navicon--active');

    const dropdown = document.querySelector('.site-header__dropdown');
    dropdown?.classList?.toggle('site-header__dropdown--active');

    document.body.classList.remove('site-navigation--search');
    document.body.classList.toggle('site-navigation--open');
  });
}

function searchIcon() {
  const searchBtn = document.querySelector('.site-navigation__search');
  const closeBtn = document.querySelector('.site-navigation__search-area-close');

  if (searchBtn) {
    searchBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      document.body.classList.remove('site-navigation--open');
      document.body.classList.toggle('site-navigation--search');
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      document.body.classList.remove('site-navigation--search');
    });
  }
}

export { navigation, getTallestSubMenu, navicon, searchIcon };
